import dayjs from "dayjs";

// A scheduled hail must be at least this far ahead; the quote API rejects a closer
// time (backend TIME_DELTA_FOR_SCHEDULED_HAIL_MINS).
export const SCHEDULE_MIN_LEAD_MINUTES = 20;

// The time first offered when the rider picks "Schedule": 30 minutes ahead,
// rounded up to the next 5 minutes.
export const defaultScheduledTime = (): string => {
  const time = dayjs().add(30, "minute").second(0).millisecond(0);
  return time.add((5 - (time.minute() % 5)) % 5, "minute").toISOString();
};

export const isScheduleTooSoon = (scheduledTime: string | null): boolean =>
  scheduledTime !== null &&
  dayjs(scheduledTime).isBefore(dayjs().add(SCHEDULE_MIN_LEAD_MINUTES, "minute"));

// <input type="datetime-local"> works in the rider's local time, without a zone.
export const toLocalInputValue = (iso: string): string =>
  dayjs(iso).format("YYYY-MM-DDTHH:mm");

export const fromLocalInputValue = (value: string): string | null => {
  const time = dayjs(value);
  return time.isValid() ? time.toISOString() : null;
};

export const earliestScheduleInputValue = (): string =>
  toLocalInputValue(dayjs().add(SCHEDULE_MIN_LEAD_MINUTES, "minute").toISOString());
